import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Modal,
  ButtonGroup,
  DropdownButton,
  MenuItem,
  Table,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
//import Alert          from '../../../components/alert/Alert';
import { createBrowserHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import {
  getPageTemplate,
  updateTemplate,
} from "../../../redux/actions/pageTemplateAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";

import ReactHtmlParser from "react-html-parser";
import Dialog from "react-bootstrap-dialog";
import CKEditor from "react-ckeditor-component";
import Cookies from "universal-cookie";
const cookies = new Cookies();

import Pagination from "react-paginating";
const history = createBrowserHistory();

const HorizontalLine = ({}) => <hr />;

const propTypes = {
  emailOverview: PropTypes.func.isRequired,
};
let cityItems = [];
let isLoading = "false",
  csvData = [];

class EditPageTemplate extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      path: ["Home", "Page Template"],
      links: ["home", "page-template"],
      list: [],
      content: "",
      title: "",
      alert: false,
      alertMessage: "",
      submitValue: "Save",
      disabled: false,
      contentdata: "",
      french_title: "",
      french_content: "",
      multi_lang: "no",
    };

    this.content = this.content.bind(this);
    this.frenchContent = this.frenchContent.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
  }

  handleDismiss() {
    this.setState({ alert: false });
  }

  content(evt) {
    this.setState({
      contentdata: evt.editor.getData(),
    });
  }

  frenchContent(evt) {
    this.setState({
      french_content: evt.editor.getData(),
    });
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handlePageChange = () => {
    let templateType = this.props.match.params.templateType
      ? this.props.match.params.templateType
      : "";
    if (templateType) {
      isLoading = "true";
      this.props.getPageTemplate(templateType);
    }
  };

  componentWillMount() {
    let siteData = JSON.parse(localStorage.getItem("siteDDBStatus"));

    if (siteData) {
      if (siteData.multi_lang) {
        this.setState({
          multi_lang: siteData.multi_lang,
        });
      }
    }
    this.handlePageChange();
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.setState({
      submitValue: "Saving....",
      disabled: true,
    });
    let postData = {
      content: this.state.contentdata,
      templateType: this.state.templateType,
      french_title: this.state.french_title,
      french_content: this.state.french_content,
    };
    this.props.updateTemplate(postData);
  };

  handleAlertShow() {
    this.setState({ alert: true });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.templateData !== nextProps.templateData) {
      if (nextProps.templateData) {
        isLoading = "false";
        this.setState({
          title: nextProps.templateData.data.title,
          contentdata: nextProps.templateData.data.content,
          templateType: nextProps.templateData.data.templateType,
          french_title: nextProps.templateData.data.french_title,
          french_content: nextProps.templateData.data.french_content,
        });
      }
    }

    if (this.props.updateStatus !== nextProps.updateStatus) {
      if (nextProps.updateStatus) {
        this.setState({
          submitValue: "Save",
          disabled: false,
        });
        this.setState({ alert: false });
        this.handleAlertShow();
        this.props.renderAlert("success", nextProps.updateStatus.message);
        window.scrollTo(0, 0);
      }
    }

    if (this.props.error !== nextProps.error && !isEmpty(nextProps.error)) {
      this.setState({ alert: false });
      this.handleAlertShow();
      this.props.renderAlert("warning", nextProps.error);
      window.scrollTo(0, 0);
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType,
      });
    }
  }

  editSourceContent = (mode) => {
    const editor = mode.editor;

    if (editor.mode === "source") {
      const editable = editor._.editable;
      editable.attachListener(editable, "input", (e) => {
        this.content(mode);
      });
    }
  };

  editSource = (mode) => {
    const editor = mode.editor;

    if (editor.mode === "source") {
      const editable = editor._.editable;
      editable.attachListener(editable, "input", (e) => {
        this.frenchContent(mode);
      });
    }
  };

  render() {
    let x = 1;
    return (
      <div className="col-lg-12 add-sub-admin">
        <Dialog
          ref={(el) => {
            this.dialog = el;
          }}
        />
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1"></div>
              <div className="dot2"></div>
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent
              path={this.state.path}
              links={this.state.links}
              context={this.context}
            />
          </div>
        </div>
        <div className="panel">
          <header className="panel-heading">Edit Page Template Setting</header>
          <div className="panel">
            {this.state.alert && this.state.alertMessage !== "" && (
              <div className="col-lg-12">
                <Alert
                  bsStyle={this.state.msgType}
                  onDismiss={this.handleDismiss}
                >
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage}
                </Alert>
              </div>
            )}
            <div className="panel-body">
              <form onSubmit={this.handleSubmit}>
                <FormGroup>
                  <ControlLabel>Name the Page Template:</ControlLabel>
                  <FormControl
                    type="text"
                    value={this.state.title}
                    placeholder="Enter title"
                    name="title"
                    onChange={this.handleChange}
                  />
                </FormGroup>
                {this.state.multi_lang == "yes" && (
                  <FormGroup>
                    <ControlLabel>
                      Name the Page Template (Canadian French):
                    </ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.french_title}
                      placeholder="Enter title"
                      name="french_title"
                      onChange={this.handleChange}
                    />
                  </FormGroup>
                )}
                <FormGroup>
                  <ControlLabel>HTML Content:</ControlLabel>
                  <CKEditor
                    activeClass="p10"
                    name="contentdata"
                    content={this.state.contentdata}
                    events={{
                      change: this.content,
                      blur: this.content,
                      afterPaste: this.content,
                      mode: this.editSourceContent,
                    }}
                    config={{ versionCheck:false}}
                  />
                </FormGroup>
                {this.state.multi_lang == "yes" && (
                  <FormGroup>
                    <ControlLabel>HTML Content (Canadian French):</ControlLabel>
                    <CKEditor
                      activeClass="p10"
                      name="french_content"
                      content={this.state.french_content}
                      events={{
                        change: this.frenchContent,
                        blur: this.frenchContent,
                        afterPaste: this.frenchContent,
                        mode: this.editSource,
                      }}
                      config={{ versionCheck:false}}
                    />
                  </FormGroup>
                )}
                <Row className="BtnRow">
                  <Col md={12} xs={12}>
                    <Button
                      bsStyle="info"
                      type="submit"
                      id="saveButton"
                      disabled={this.state.disabled}
                    >
                      {this.state.submitValue}
                    </Button>
                    <Button
                      bsStyle="default"
                      onClick={() =>
                        this.context.router.history.push(`/page-template`)
                      }
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
                {this.props.match.params.templateType ===
                  "ProposalContract" && (
                  <Row>
                    <Col md={12} xs={12}>
                      <Table striped bordered condensed hover>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Short Code</th>
                            <th>Detail</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{merchantLegalName}"}</td>
                            <td>Merchant Legal Name</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{address1}"}</td>
                            <td>Address 1</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{address2}"}</td>
                            <td>Address 2</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{city}"}</td>
                            <td>City</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{state}"}</td>
                            <td>State</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{country}"}</td>
                            <td>Country</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{zip}"}</td>
                            <td>Zip</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{phone}"}</td>
                            <td>Phone</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{salesManagerName}"}</td>
                            <td>Sales Manager Name</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{salesManagerEmail}"}</td>
                            <td>Sales Manager Email</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{salesManagerPhone}"}</td>
                            <td>Sales Manager Phone</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{siteName}"}</td>
                            <td>Site Name</td>
                          </tr>
                          <tr>
                            <td>19</td>
                            <td>${"{siteName}"}</td>
                            <td>Site Name</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{offerTitle}"}</td>
                            <td>Offer Title</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{expiration}"}</td>
                            <td>Expiration Date</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{retailPrice}"}</td>
                            <td>Retail Price</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{perCustomer}"}</td>
                            <td>Max Per Customer</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{offerPrice}"}</td>
                            <td>Offer Price</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{remittance}"}</td>
                            <td>Remittance to merchant</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{remittancePercent}"}</td>
                            <td>Remittance Percent to merchant</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{maxAvailable}"}</td>
                            <td>Maximum Available qunatity</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{maxOverall}"}</td>
                            <td>Maximum overall available qunatity</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{expirationMonth}"}</td>
                            <td>Number of month in which voucher expire </td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{DateTime}"}</td>
                            <td>Current Date time</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{additionalGifts}"}</td>
                            <td>Max As Gifts</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{agreeTermCondition}"}</td>
                            <td>Term and Condition</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>${"{agreeTermCondition1}"}</td>
                            <td>Term and Condition 1</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>
                              {
                                "${standard_proposalStart} ${standard_proposalEnd}"
                              }
                            </td>
                            <td>Standard Merchant</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>
                              {
                                "${premium_proposalStart} ${premium_proposalEnd}"
                              }
                            </td>
                            <td>Premium Merchant</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>
                              {
                                "${products_proposalStart} ${products_proposalEnd}"
                              }
                            </td>
                            <td>Products</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>
                              {"${events_proposalStart} ${events_proposalEnd}"}
                            </td>
                            <td>Travel</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>
                              {"${travel_proposalStart} ${travel_proposalEnd}"}
                            </td>
                            <td>Events</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>
                              {"${coupon_proposalStart} ${coupon_proposalEnd}"}
                            </td>
                            <td>Coupon Offer</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>
                              {
                                "${affiliate_proposalStart} ${affiliate_proposalEnd}"
                              }
                            </td>
                            <td>Affiliate Offer</td>
                          </tr>
                          <tr>
                            <td>{x++}</td>
                            <td>
                              {
                                "${gift_card_proposalStart} ${gift_card_proposalEnd}"
                              }
                            </td>
                            <td>Gift Card Vouchers</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                )}
                {this.props.match.params.templateType === "VoucherTemplate" && (
                  <Row>
                    <Col md={12} xs={12}>
                      <Table striped bordered condensed hover>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Short Code</th>
                            <th>Detail</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>01</td>
                            <td>${"{{voucherNumber}}"}</td>
                            <td>Voucher Number</td>
                          </tr>
                          <tr>
                            <td>02</td>
                            <td>${"{{dealText}}"}</td>
                            <td>Main Deal/Offer Text</td>
                          </tr>
                          <tr>
                            <td>03</td>
                            <td>${"{{expiryDate}}"}</td>
                            <td>Voucher Expiry Date</td>
                          </tr>
                          <tr>
                            <td>04</td>
                            <td>${"{{termsAndConditions}}"}</td>
                            <td>Terms And Conditions</td>
                          </tr>
                          <tr>
                            <td>05</td>
                            <td>${"{{merchantName}}"}</td>
                            <td>Merchant Name</td>
                          </tr>
                          <tr>
                            <td>06</td>
                            <td>${"{{merchant_logo}}"}</td>
                            <td>Merchant Logo</td>
                          </tr>
                          <tr>
                            <td>07</td>
                            <td>${"{{retailPrice}}"}</td>
                            <td>Retail Price</td>
                          </tr>
                          <tr>
                            <td>08</td>
                            <td>${"{{defaultCurrency}}"}</td>
                            <td>Default Currency</td>
                          </tr>
                          <tr>
                            <td>09</td>
                            <td>${"{{offerPrice}}"}</td>
                            <td>Offer Price</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>${"{{totalAmount}}"}</td>
                            <td>Amount Charged</td>
                          </tr>
                          <tr>
                            <td>11</td>
                            <td>${"{{order_date}}"}</td>
                            <td>Order Date</td>
                          </tr>
                          <tr>
                            <td>12</td>
                            <td>${"{{deal_option}}"}</td>
                            <td>Attribute Value</td>
                          </tr>
                          <tr>
                            <td>13</td>
                            <td>${"{{merchantAddress}}"}</td>
                            <td>Merchant Location Address</td>
                          </tr>
                          <tr>
                            <td>14</td>
                            <td>${"{{locationName}}"}</td>
                            <td>Location Name</td>
                          </tr>
                          <tr>
                            <td>15</td>
                            <td>{"{{giftee}}"}</td>
                            <td>Gift Recipient Name</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                )}

                {this.props.match.params.templateType ===
                  "GiftCardVoucherTemplate" && (
                  <Row>
                    <Col md={12} xs={12}>
                      <Table striped bordered condensed hover>
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Short Code</th>
                            <th>Detail</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>01</td>
                            <td>{"{{voucherCode}}"}</td>
                            <td>Voucher Number</td>
                          </tr>
                          <tr>
                            <td>02</td>
                            <td>{"{{dealText}}"}</td>
                            <td>Main Deal/Offer Text</td>
                          </tr>
                          <tr>
                            <td>03</td>
                            <td>{"{{termsAndConditions}}"}</td>
                            <td>Terms And Conditions</td>
                          </tr>
                          <tr>
                            <td>04</td>
                            <td>{"{{merchant_logo}}"}</td>
                            <td>Merchant Logo</td>
                          </tr>
                          <tr>
                            <td>06</td>
                            <td>{"{{purchaserName}}"}</td>
                            <td>Customer Name</td>
                          </tr>
                          <tr>
                            <td>07</td>
                            <td>{"{{dealImage}}"}</td>
                            <td>Deal Image</td>
                          </tr>
                          <tr>
                            <td>08</td>
                            <td>{"{{giftCardVoucherAmount}}"}</td>
                            <td>Gift Card Voucher Amount</td>
                          </tr>
                          <tr>
                            <td>09</td>
                            <td>{"{{barcode}}"}</td>
                            <td>Bar Code</td>
                          </tr>
                          <tr>
                            <td>10</td>
                            <td>{"{{qrcode}}"}</td>
                            <td>QR Code</td>
                          </tr>
                          <tr>
                            <td>11</td>
                            <td>{"{{merchantAddress}}"}</td>
                            <td>Merchant Location Address</td>
                          </tr>
                          <tr>
                            <td>12</td>
                            <td>{"{{merchantName}}"}</td>
                            <td>Merchant Name</td>
                          </tr>
                          <tr>
                            <td>13</td>
                            <td>{"{{locationName}}"}</td>
                            <td>Location Name</td>
                          </tr>
                          <tr>
                            <td>14</td>
                            <td>{"{{giftee}}"}</td>
                            <td>Gift Recipient Name</td>
                          </tr>
                          <tr>
                            <td>15</td>
                            <td>{"{{createdOn}}"}</td>
                            <td>Order Date</td>
                          </tr>
                          <tr>
                            <td>16</td>
                            <td>{"{{notes}}"}</td>
                            <td>Note</td>
                          </tr>
                        </tbody>
                      </Table>
                    </Col>
                  </Row>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    templateData: state.pageTemplateReducer.templateData,
    updateStatus: state.pageTemplateReducer.updateStatus,
    error: state.pageTemplateReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    getPageTemplate,
    updateTemplate,
    renderAlert,
    clearAlert,
  })
)(EditPageTemplate);



// WEBPACK FOOTER //
// ./src/app/views/admin/pageTemplate/EditPageTemplate.js